import * as React from "react";
const SvgArrow = props => <svg xmlns="http://www.w3.org/2000/svg" width={15} height={14} fill="none" viewBox="0 0 15 14" {...props}><path fill="currentColor" d="m10.977 6.167-4.47-4.47L7.686.519 14.167 7l-6.481 6.482-1.179-1.178 4.47-4.47H.834V6.167z" /></svg>;
export default SvgArrow;